import React, { Component } from "react";
import BannerCarousel from "../components/BannerCarousel";
import NearbyPartnerCarousel from "../components/NearbyPartnerCarousel";
import VoucherCarousel from "../components/VoucherCarousel";
import BillPayCarousel from "../components/BillPayCarousel";
import client from "../../../utils/client";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { setHome, setHomeAfterBookmarkToggle, setLoading, setCounterData, setWrp } from "../actions";
import { FormattedMessage } from "react-intl";
import lodash from "lodash";
import { currentlySelectedLanguage } from "../../../utils/helper";
import { FirebaseContext } from "../../../utils/firebase";
import { onGenericAction, onReferred } from "../../../utils/events";
import ic_copy from "../../../assets/home/ic_copy.svg";
import ic_share from "../../../assets/home/ic_share.svg";
import { toast } from "react-toastify";
import arrow from "../../../assets/home/ic_view_arrow.svg"
import viewAll from "../../../assets/home/ic_view_all_arrow.svg"
import insuranceBG0 from "../../../assets/home/ic_rectangle_bike.png"
import insuranceBG1 from "../../../assets/home/ic_rectangle_car.png"
import insuranceBG2 from "../../../assets/home/ic_rectangle_health.png"
import referEarnMockup from "../../../assets/img/site-patrons/ic_app_features.png"

class Home extends Component {
  static contextType = FirebaseContext;

  state = {
    showWrpTooltip: false,
    isRedeemWrpModelOpen: false,
    redeemableWrp: null,
    profile: null,
    referrer_wrp: null,
    heading_text: this.props.heading_text,
    URL: [
      { key: "vouchers", url: "/vouchers" },
      { key: "nearby_partners", url: "/nearby-partners" },
      { key: "shopping", url: "/shopping-sites" },
      { key: "bill_pay", url: "/bill-pay" },
      { key: "wrp", url: "/coupons" },
      { key: "wallet", url: "/wallet" },
      { key: "my_earning", url: "/earnings" },
      { key: "rewards", url: "/rewards" }
    ],
    insuranceBG: [
      { bgImage: insuranceBG1, color: "#289186", buttonBG: "#58C8BB" },
      { bgImage: insuranceBG0, color: "#C44760", buttonBG: "#FB90A5" },
      { bgImage: insuranceBG2, color: "#6F53C2", buttonBG: "#AB93F0" }
    ],
    insuranceDescrption: [
      { desc: `${<FormattedMessage id="health-insurance-desc" />}` }
    ]
  };

  componentDidMount() {
    onGenericAction("Home Screen Loaded");
    const { app_maintenance } = this.context;

    if (!app_maintenance) {
      this.props.onInit(this.props.latitude, this.props.longitude);
      setTimeout(() => {
        this.props.profile && this.props.getCoupons();
      }, 3000)
    } else {
      window.location.href = `${process.env.REACT_APP_BASE_URL_APP_MAINTENANCE}/${currentlySelectedLanguage()}`;
    };
    this.props.getWrpValues(this.props.latitude, this.props.longitude)
  }

  componentDidUpdate(prevProps) {
    if (this.context.app_maintenance) {
      window.location.href = `${process.env.REACT_APP_BASE_URL_APP_MAINTENANCE
        }/${currentlySelectedLanguage()}`;
    }
    if (this.props.latitude !== prevProps.latitude) {
      this.props.onInit(this.props.latitude, this.props.longitude);
    }
    if (this.props.total_points !== prevProps.total_points) {
      const redeemableWrp = (this.props.active_coupons * this.props.total_points_per_coupon + this.props.total_points);
      this.setState({ redeemableWrp })
    }
  }

  referred = () => {
    onReferred();
  }

  onMouseEnterOnProgressBar = () => {
    this.setState({
      showWrpTooltip: true,
    });
  };

  onMouseLeaveOnProgressBar = () => {
    this.setState({
      showWrpTooltip: false,
    });
  };

  onCopy = (e) => {
    this.code.select();
    document.execCommand("copy");
    toast.success(
      <FormattedMessage
        id="general.code-copied"
        defaultMessage="Code copied successfully."
      />,
      {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      }
    );
    e.target.focus();
  };

  onToggleBookmark = (id, isBookmarked, url, type) =>
    !isBookmarked
      ? this.props.addBookmark(
        id,
        type,
        url,
        this.props.banner,
        this.props.affiliate,
        this.props.partner,
        this.props.voucher,
        this.props.billpay,
        this.props.offers,
        this.props.tags
      )
      : this.props.deleteBookmark(
        id,
        type,
        url,
        this.props.banner,
        this.props.affiliate,
        this.props.partner,
        this.props.voucher,
        this.props.billpay,
        this.props.offers,
        this.props.tags
      );

  render() {
    return (
      this.props.banner.length === 0 ? <this.Shimmer /> : (
        <React.Fragment>
          <this.ServiceCategories />
          <BannerCarousel banner={this.props.banner} />
          {this.props.voucher.length > 0 && <this.Vouchers />}
          <this.NearbyPartners />
          {!this.props.profile && <this.Refer />}
          {this.props.profile && <this.hasProfileRefer />}
          <this.BillPayments />
          {this.props?.insurance && <this.Insurance />}
          {/* {this.props?.heading_text?.travel && <this.Travel />} */}
          <this.ShoppingSites />
          {/* {this.props.deals && this.props.deals.length > 0 && <this.deals />} */}
          {/* <this.eCommerceBanner /> */}
          {/* <this.ShopNow /> */}
          {/* <this.Offers /> */}
          {/* <AllBrands tags={this.props.tags} /> */}
        </React.Fragment>
      )
    )
  }

  Shimmer = (props) => {
    return (
      <React.Fragment>
        <div className="shine slider-shimmer"></div>
        {lodash.range(4).map((index) => {
          return (
            <div className="container-fluid container-fluid--home-section" key={index} >
              <div className="row row--home-section-title">
                <div className="col-md-12">
                  <div className="heading shine"></div>
                </div>
              </div>
              <div className="row">
                <div className="col-4 col-md-3">
                  <div className="box shine"></div>
                </div>
                <div className="col-4 col-md-3">
                  <div className="box shine"></div>
                </div>
                <div className="col-4 col-md-3">
                  <div className="box shine"></div>
                </div>
                <div className="col-4 col-md-3 d-none d-md-block">
                  <div className="box shine"></div>
                </div>
              </div>
            </div>
          );
        })}
      </React.Fragment>
    );
  };

  ServiceCategories = (props) => {
    return (
      <React.Fragment>
        <section className="home-page section-space service-categories">
          <div className="container font-proxima-nova">
            <div className="row home-reverse">
              <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 d-flex flex-column justify-content-start">
                <h1 className="title"><FormattedMessage id="home.section1.title" /></h1>
                <p className="title-slim"><FormattedMessage id="home.section1.subtitle" /></p>
                <p className="desc"><FormattedMessage id="home.section1.desc" /></p>
                <div className="space"></div>
                <h1 className="title mb-4"><span className="font-slim"><FormattedMessage id="home.section1.shop-by" /></span> <FormattedMessage id="home.section1.categories" /></h1>
                <div className="row service-categories-link">
                  {this.props.service_categories && this.props.service_categories.map((item, index) => {
                    return (
                      <div key={index} className="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 d-flex flex-column align-items-center mb-3">
                        <Link to={`${this.state?.URL[index]['url']}`}>
                          <div className="box">
                            <img className="icon" src={item.icon} alt={item.key} />
                            <img className="arrow" src={arrow} alt="arrow" />
                          </div>
                          <p className="box-title">{item.value}</p>
                        </Link>
                      </div>
                    )
                  })}
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 d-flex flex-column justify-content-start">
                <img className="categories-img" src={require('../../../assets/home/ic_catogery_bg.png')} alt="categories" />
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    )
  }

  Vouchers = (props) => {
    let wrp;
    if (this.props.heading_text && this.props.heading_text.nearby_voucher) {
      wrp = this.props.heading_text.nearby_voucher.wrp
    };

    return (
      <div className="home-page section-space home-vouchers">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-9">
              <h1 className="title"><FormattedMessage id="home.online-vouchers" /></h1>
            </div>
            <div className="col-3 text-right">
              <Link to={{ pathname: "/vouchers", state: { from: "/" } }}>
                <h3 className="title-thick d-flex justify-content-end mobile-hide">
                  <FormattedMessage
                    id="home.view-all"
                    defaultMessage="View All"
                    values={{ what: "react-intl" }}
                  />
                  <img className="view-all" src={viewAll} alt="view all" />
                </h3>
              </Link>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <h3 className="title-thick font-slim"><FormattedMessage id="home.online-vouchers-desc1" /> {wrp} <FormattedMessage id="home.online-vouchers-desc2" /> </h3>
            </div>
          </div>
          <div className="row d-flex justify-content-between mt-3">
            {this.props.voucher.length > 0 && (
              <VoucherCarousel
                vouchers={this.props.voucher}
                onToggleBookmarkVouchers={(id, isBookmarked, url, type) => {
                  this.onToggleBookmark(id, isBookmarked, url, type);
                }}
              />
            )}
          </div>
        </div>
      </div>
    );
  };

  NearbyPartners = (props) => {
    return (
      <div className="home-page section-space home-nearby-partners">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-9">
              <h1 className="title"><FormattedMessage id="categories-nearby" /></h1>
            </div>
            <div className="col-3 text-right">
              <Link to={{ pathname: "/nearby-partners/categories", state: { from: "/" } }}>
                <h3 className="title-thick d-flex justify-content-end mobile-hide">
                  <FormattedMessage
                    id="home.view-all"
                    defaultMessage="View All"
                    values={{ what: "react-intl" }}
                  />
                  <img className="view-all" src={viewAll} alt="view all" />
                </h3>
              </Link>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <h3 className="title-thick font-slim"><FormattedMessage id="categories-nearby-desc1" /> 100% WRP <FormattedMessage id="categories-nearby-desc2" /></h3>
            </div>
          </div>
          <div className="row d-flex justify-content-between mt-4">
            <div className="col-12">
              {this.props.partner.length > 0 && (
                <NearbyPartnerCarousel partners={this.props.partner} />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  Refer = (props) => {
    return (
      <React.Fragment>
        <section className="home-page section-space home-refer-earn">
          <div className="container font-proxima-nova">
            <div className="row">
              <div className="col-12 col-sm-12 col-md-5 col-lg-5 col-xl-5 d-flex flex-column justify-content-center">
                <p className="title"><span className="font-slim"> <FormattedMessage id="home.download-title-abouve" /></span></p>
                <div className="space"></div>
                <h1 className="title"><FormattedMessage id="home.download-title" /></h1>
                <p className="desc "><FormattedMessage id="home.download-desc" /></p>
                <div className="space"></div>
                <h2 className="title-thick mb-3"><FormattedMessage id="home.download-subtitle" /></h2>
                <div className="paystore">
                  <a href="https://winds.to/app" target="blank">
                    <img className="icons" src={require('../../../assets/img/site-patrons/ic_google_pay.png')} alt="icon" />
                  </a>
                  <a href="https://winds.to/app" target="blank">
                    <img className="icons" src={require('../../../assets/img/site-patrons/ic_app_store.png')} alt="about" />
                  </a>
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-7 col-lg-7 col-xl-7 d-flex flex-column justify-content-start">
                <img className="refer-mock" src={referEarnMockup} alt="login" />
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    )
  }

  hasProfileRefer = (props) => {
    const { referral_code, referral_link, name } = this.props.profile;

    return (
      <React.Fragment>
        <section className="home-page section-space home-refer-earn">
          <div className="container font-proxima-nova">
            <div className="row">
              <div className="col-12 col-sm-12 col-md-5 col-lg-5 col-xl-5 d-flex flex-column justify-content-center">
                <p className="title"><span className="font-slim"><FormattedMessage id="home.download-title-abouve" /></span></p>
                <div className="space"></div>

                <h1 className="title"><FormattedMessage id="home.download-title" /></h1>
                <p className="desc w-75"><FormattedMessage id="home.download-desc" /></p>
                <div className="space"></div>
                <h2 className="title-thick mb-3"><FormattedMessage id="home.download-subtitle" /></h2>
                <div className="paystore">
                  <a href="https://winds.to/app" target="blank">
                    <img className="icons" src={require('../../../assets/img/site-patrons/ic_google_pay.png')} alt="icon" />
                  </a>
                  <a href="https://winds.to/app" target="blank">
                    <img className="icons" src={require('../../../assets/img/site-patrons/ic_app_store.png')} alt="about" />
                  </a>
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-7 col-lg-7 col-xl-7 d-flex flex-column justify-content-start">
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-5 col-lg-5 col-xl-5">
                    <div className="refer-earn-box">
                      <img className="refer-img" src={require('../../../assets/home/ic_wrp_coin_box.png')} alt="wrp" />
                      <h1 className="title text-white mt-3"><FormattedMessage id="home.refer" /> <br className="d-md-block d-none" /><FormattedMessage id="home.earn" /></h1>
                      <p className="desc text-white"><FormattedMessage id="home.refer-desc" /></p>
                      <div className="input-group mb-4">
                        <input
                          type="text"
                          ref={(code) => (this.code = code)}
                          className="form-control refferal-code-input"
                          value={this.props.profile.referral_code ? this.props.profile.referral_code : ""}
                          readOnly
                        />
                        <div className="input-group-append">
                          <span
                            className="input-group-text px-3"
                            onClick={this.onCopy}
                          >
                            <img className="share-copy" src={ic_copy} alt="ic_copy" />
                          </span>
                          <span className="input-group-text px-3 share-links" style={{ cursor: "pointer", background: "#FF5F00" }}>
                            <img className="share-copy" src={ic_share} alt="ic_share" />
                            <div className="share-links-dropdown">
                              <div className="d-flex justify-content-center align-items-center">
                                <a
                                  onClick={this.referred}
                                  title={`Share on facebook`}
                                  href={encodeURI(
                                    `https://www.facebook.com/sharer/sharer.php?u=${referral_link}`
                                  )}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <i className="fab fa-facebook-square" aria-hidden="true" style={{ fontSize: "30px", color: "#4267B2" }}></i>
                                </a>
                                <a
                                  onClick={this.referred}
                                  href={`https://web.whatsapp.com/send?text=A+brilliant+opportunity+to+WIN+BIG+CASH+REWARDS+by+just+doing+your+daily+shopping+through+the+WINDS+App.%0D%0A%0D%0ADo+your+regular+transactions%3A%0D%0A%E2%97%8F+Offline+and+Online+Shopping%0D%0A%E2%97%8F+Utility+Bill+Payments%0D%0A%E2%97%8F+Purchasing+Brand+Vouchers%0D%0A%5Bwith+upto+25%25+discount%5D%0D%0A%0D%0ALink%3A+${referral_link}%0D%0A%E2%96%BA+Earn+WINDS+Reward+Points+%5BWRP%5D+on+every+purchase+of+yours+%5BNote%3A+%E2%82%B9+1+spent+%3D+1+WRP+earned+on+every+transaction%5D%0D%0A%E2%96%BA+Collect+a+total+of+5000+WRP+to+enter+into+a+Monthly+Lucky+Draw+and+WIN+LAKHS+%26amp%3B+CRORES%2A.%0D%0A%E2%96%BA+Also+EARN+10%25+of+WINDS%E2%80%99+earnings+on+every+purchase+your+referral+makes+via+the+WINDS+Referral+Program.%0D%0A%0D%0APlease+enter+my+referral+code+${referral_code}+or+click+on+the+link+below%2C+download+the+WINDS+App+and+become+a+part+of+the+World%E2%80%99s+Largest+Happiness+Program+today%21%0D%0A%0D%0ALink%3A+${referral_link}%0D%0ABest+Regards%2C%0D%0A${name}`}
                                  data-action="share/whatsapp/share"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  title="Share on whatsapp"
                                >
                                  {" "}
                                  <i className="fab fa-whatsapp-square" aria-hidden="true" style={{ fontSize: "30px", color: "#25D366" }}></i>
                                </a>
                                <a
                                  onClick={this.referred}
                                  href={`https://twitter.com/intent/tweet?text=A+brilliant+opportunity+to+WIN+BIG+CASH+REWARDS+by+just+doing+your+daily+shopping+through+the+WINDS+App.%0D%0A%0D%0ADo+your+regular+transactions%3A%0D%0A%E2%97%8F+Offline+and+Online+Shopping%0D%0A%E2%97%8F+Utility+Bill+Payments%0D%0A%E2%97%8F+Purchasing+Brand+Vouchers%0D%0A%5Bwith+upto+25%25+discount%5D%0D%0A%0D%0ALink%3A+${referral_link}%0D%0A%E2%96%BA+Earn+WINDS+Reward+Points+%5BWRP%5D+on+every+purchase+of+yours+%5BNote%3A+%E2%82%B9+1+spent+%3D+1+WRP+earned+on+every+transaction%5D%0D%0A%E2%96%BA+Collect+a+total+of+5000+WRP+to+enter+into+a+Monthly+Lucky+Draw+and+WIN+LAKHS+%26amp%3B+CRORES%2A.%0D%0A%E2%96%BA+Also+EARN+10%25+of+WINDS%E2%80%99+earnings+on+every+purchase+your+referral+makes+via+the+WINDS+Referral+Program.%0D%0A%0D%0APlease+enter+my+referral+code+${referral_code}+or+click+on+the+link+below%2C+download+the+WINDS+App+and+become+a+part+of+the+World%E2%80%99s+Largest+Happiness+Program+today%21%0D%0A%0D%0ALink%3A+${referral_link}%0D%0ABest+Regards%2C%0D%0A${name}`}
                                  data-action="share/whatsapp/share"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  title="Share on Twitter"
                                >
                                  {" "}
                                  <i className="fab fa-twitter-square" aria-hidden="true" style={{ fontSize: "30px", color: "#1DA1F2" }}></i>
                                </a>
                                <a
                                  onClick={this.referred}
                                  href={encodeURI(`https://www.linkedin.com/sharing/share-offsite/?url=${referral_link}`)}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  title="Share on LinkedIn"
                                >
                                  <i className="fab fa-linkedin" aria-hidden="true" style={{ fontSize: "30px", color: "#0072b1" }} ></i>
                                </a>
                              </div>
                            </div>
                          </span>
                        </div>
                      </div>
                      <Link to="/refer-and-earn">
                        <span className="font-button button-color1">
                          <FormattedMessage id="home.knowmore" />
                          <img src={require('../../../assets/home/ic_arrow_white.png')} alt="know more" />
                        </span>
                      </Link>
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-7 col-lg-7 col-xl-7">
                    <div className="d-flex flex-column">
                      <div className="what-is-wrp">
                        <img className="wrp-img" src={require('../../../assets/home/ic_coins.png')} alt="wrp" />
                        <h1 className="title text-white"><FormattedMessage id="home.what-is" /> <br className="d-md-block d-none" /><FormattedMessage id="home.wrp" />?</h1>
                        <p className="desc text-white"><FormattedMessage id="home.what-is-wrp-desc" /></p>
                        <Link to="/wrp-details">
                          <span className="font-button button-color2">
                            <FormattedMessage id="home.knowmore" />
                            <img src={require('../../../assets/home/ic_arrow_white.png')} alt="know more" />
                          </span>
                        </Link>
                      </div>
                      <div className="space"></div>
                      <div className="wrp-coupons mt-md-4 mt-2">
                        <img className="coupons-img" src={require('../../../assets/home/ic_rewards_trophy.png')} alt="coupons" />
                        <h1 className="title text-white"><FormattedMessage id="home.wrp" /> & <br className="d-md-block d-none" /><FormattedMessage id="home.coupons" /></h1>
                        <div className="d-flex align-items-end justify-content-between mt-4">
                          <div style={{ width: "80%" }} className="d-flex wrp-coup">
                            <div className="wrp">
                              <h4>{this.props?.wrp?.wrp?.confirmed_wrp || 0}</h4>
                              <p className="desc text-white mb-0 mr-2"><FormattedMessage id="wrp.confirmed-wrp" /></p>
                            </div>
                            <div className="coupons">
                              <h4>{this.props?.wrp?.wrp?.monthly_draw_eligible_coupon || 0}</h4>
                              <p className="desc text-white mb-0"><FormattedMessage id="coupon.current_months_coupon" /></p>
                            </div>
                          </div>
                          <Link to="/coupons">
                            <span className="font-button button-color3">
                              <img src={require('../../../assets/home/ic_arrow_white.png')} alt="know more" />
                            </span>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    )
  }

  BillPayments = (props) => {
    let wrp;
    if (this.props.heading_text && this.props.heading_text.recharge) {
      wrp = this.props.heading_text.recharge.wrp
    };
    return (
      <div className="home-page section-space home-billpay">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-9">
              <h1 className="title"><FormattedMessage id="home.utility-bill-title" /></h1>
            </div>
            <div className="col-3 text-right">
              <Link to={{ pathname: "/bill-pay", state: { from: "/" } }}>
                <h3 className="title-thick d-flex justify-content-end mobile-hide">
                  <FormattedMessage
                    id="home.view-all"
                    defaultMessage="View All"
                    values={{ what: "react-intl" }}
                  />
                  <img className="view-all" src={viewAll} alt="view all" />
                </h3>
              </Link>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <h3 className="title-thick font-slim"><FormattedMessage id="home.utility-bill-desc1" /> {wrp} <FormattedMessage id="home.utility-bill-desc2" /></h3>
            </div>
          </div>
          <div className="row d-flex justify-content-between mt-4">
            <div className="col-12">
              {this.props.billpay.length > 0 && (
                <BillPayCarousel services={this.props.billpay} />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  Insurance = (props) => {
    let wrp;
    if (this.props.heading_text && this.props.heading_text.insurance) {
      wrp = this.props.heading_text.insurance.wrp
    };
    return (
      <div className="home-page section-space home-insurance">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-9">
              <h1 className="title"><span className="font-slim"><FormattedMessage id="home.insurance-title1" /></span> <FormattedMessage id="home.insurance-title2" /><span className="font-slim"><FormattedMessage id="home.insurance-title3" /></span></h1>
            </div>
            <div className="col-3 text-right">
              <Link to={{ pathname: "/insurance", state: { from: "/" } }}>
                <h3 className="title-thick d-flex justify-content-end mobile-hide">
                  <FormattedMessage
                    id="home.view-all"
                    defaultMessage="View All"
                    values={{ what: "react-intl" }}
                  />
                  <img className="view-all" src={viewAll} alt="view all" />
                </h3>
              </Link>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <h3 className="title-thick font-slim"><FormattedMessage id="home.insurance-desc1" /> {wrp} <FormattedMessage id="home.insurance-desc2" /></h3>
            </div>
          </div>
          <div className="row d-flex justify-content-between mt-4">
            {this.props?.insurance && this.props?.insurance.length > 1 ?
              (
                this.props.insurance.map((item, index) => {
                  return (
                    <div className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 d-flex" key={index}>
                      <div className="insurance-box d-flex flex-column align-items-start"
                        style={{ backgroundImage: `url(${this.state?.insuranceBG[index]?.bgImage})` }}
                      >
                        <img src={item.web_image} alt="wrp" />
                        <h1 style={{ color: `${this.state?.insuranceBG[index]?.color}` }} className="title mt-4 w-50 text-uppercase">{item.title}</h1>
                        <p className="desc mt-2 text-black">{this.state?.insuranceDescrption[index]?.desc}</p>
                        <a rel="noopener noreferrer" href={item.url} target="_blank">
                          <span style={{ background: `${this.state?.insuranceBG[index]?.buttonBG}` }} className="font-button mt-2">
                            <FormattedMessage id="home.insure-now" />
                            <img src={require('../../../assets/home/ic_arrow_white.png')} alt="know more" />
                          </span>
                        </a>
                      </div>
                    </div>
                  )
                })
              ):
              (
                this.props.insurance.map((item, index) => {
                  return (
                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex" key={index}>
                      <div className="insurance-box single-padding d-flex flex-row align-items-center justify-content-between mb-0"
                        style={{ backgroundImage: `url(${this.state?.insuranceBG[index]?.bgImage})` }}>
                        <div>
                          <h1 style={{ color: `${this.state?.insuranceBG[index]?.color}` }} className="title text-uppercase">{item.title}</h1>
                          <p className="desc mt-2 text-black"><FormattedMessage id="home.health-insurance-desc" /></p>
                          <a rel="noopener noreferrer" href={item.url} target="_blank">
                            <span style={{ background: `${this.state?.insuranceBG[index]?.buttonBG}` }} className="font-button mt-2">
                              <FormattedMessage id="home.insure-now" />
                              <img src={require('../../../assets/home/ic_arrow_white.png')} alt="arrow" />
                            </span>
                          </a>
                        </div>
                        <img className="ins-single" src={item.web_image} alt="insurance" />
                      </div>
                    </div>
                  )
                })
              )
            }
          </div>
        </div>
      </div>
    );
  };

  Travel = (props) => {
    let percentage;
    if (this.props.heading_text && this.props.heading_text.travel) {
      percentage = this.props.heading_text.travel.percentage
    };
    return (
      <div className="home-page section-space home-travel">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-9">
              <h1 className="title">Travel<span className="font-slim"> - Adding a Joy to your Journey</span></h1>
            </div>
            <div className="col-3 text-right">
              <Link to={{ pathname: "/", state: { from: "/" } }}>
                <h3 className="title-thick d-flex justify-content-end mobile-hide">
                  <FormattedMessage
                    id="home.view-all"
                    defaultMessage="View All"
                    description="View All"
                    values={{ what: "react-intl" }}
                  />
                  <img className="view-all" src={viewAll} alt="view all" />
                </h3>
              </Link>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <h3 className="title-thick font-slim">Book your Flight Tickets & Hotels at the best available rates through WINDS and {percentage}</h3>
            </div>
          </div>
          <div className="row d-flex justify-content-between mt-4">
            {/* {
              this.props?.insurance &&
              this.props.insurance.map((item, index) => {
                return ( */}
            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex" >
              <div className="travel-box d-flex flex-row align-items-center justify-content-between">
                <div>
                  <h1 className="title text-white">Flight Booking</h1>
                  <p className="desc mt-2 text-white">Let your take off be as smooth as your landing! Explore the most economical fares while booking tickets on all airline services through WINDS. </p>
                  <Link to="/">
                    <span className="font-button button-color4 mt-2">
                      Book Now
                      <img src={require('../../../assets/home/ic_arrow_white.png')} alt="arrow" />
                    </span>
                  </Link>
                </div>
                <img className="travel-img" src={require('../../../assets/home/ic_flight.png')} alt="flights" />
              </div>
            </div>
            {/* )
              })
            } */}
          </div>
        </div>
      </div>
    );
  };

  ShoppingSites = (props) => {
    return (
      <div className="home-page section-space home-shopping-sites">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-9">
              <h1 className="title"><FormattedMessage id="home.shoppingsites-title1" /><span className="font-slim"><FormattedMessage id="home.shoppingsites-title2" /></span></h1>
            </div>
            <div className="col-3 text-right">
              <Link to={{ pathname: "/shopping-sites", state: { from: "/" } }}>
                <h3 className="title-thick d-flex justify-content-end mobile-hide">
                  <FormattedMessage
                    id="home.view-all"
                    defaultMessage="View All"
                    values={{ what: "react-intl" }}
                  />
                  <img className="view-all" src={viewAll} alt="view all" />
                </h3>
              </Link>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <h3 className="title-thick font-slim"><FormattedMessage id="home.shoppingsites-desc1" /> <FormattedMessage id="home.shoppingsites-desc2" /></h3>
            </div>
          </div>
          <div className="row d-flex justify-content-between mt-4">
            <div className="col-12">
              <div className="shopping-box">
                {this.props.affiliate.length > 0 &&
                  this.props.affiliate.map((item, index) => {
                    return (
                      <Link className="shopping-box-image d-flex justify-content-center" to={`/shopping-sites/${item.id}`} key={index}>
                        <img src={item.image_url} alt={item.name} />
                      </Link>
                    )
                  })
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

}

function mapStateToProps(state) {
  return {
    latitude: state.location.latitude,
    longitude: state.location.longitude,
    banner: state.home.banner,
    heading_text: state.home.heading_text,
    affiliate: state.home.affiliate,
    partner: state.home.partner,
    voucher: state.home.voucher,
    billpay: state.home.billpay,
    offers: state.home.offers,
    tags: state.home.tags,
    deals: state.home.deals,
    isLoading: state.home.isLoading,
    wrp: state.wrp,
    customer_order_commission: state.wrp.customer_order_commission,
    profile: state.global.profile,
    home: state.home,
    service_categories: state.home.service_categories,
    insurance: state.home.insurance,
    rewards: state.home.rewards
  };
}

function mapDispatchToProps(dispatch) {
  return {

    onInit: (latitude, longitude) => {
      dispatch(setLoading(true));
      client
        .get(
          "/v2/?latitude=" +
          latitude +
          "&longitude=" +
          longitude +
          "&feature=1" +
          "&radius=5" +
          "&banner_lang=" +
          currentlySelectedLanguage()
        )
        .then((response) => {
          var data = response.data.data;
          const billPayServices = data.billpay.services.filter(
            (item) => Number(item.id) !== 2
          );
          billPayServices[0].name = "Mobile";

          dispatch(
            setHome(
              data.banner,
              data.heading_text,
              data.affiliate,
              data.partner.categories,
              data.voucher,
              billPayServices,
              data.partner.offers,
              data.tags,
              data.customer_order_commission,
              data.wrp,
              data.insurance,
              data.service_categories,
              data.rewards
            )
          );
          dispatch(setLoading(false));
        });
    },

    getCoupons: () => {
      client.get("v1/coupons").then((response) => {
        const {
          active_coupons,
          total_points,
          pending_points,
          coupon_progression_percent,
          total_points_per_coupon,
        } = response.data.data;
        dispatch(
          setCounterData(
            active_coupons,
            total_points,
            pending_points,
            coupon_progression_percent,
            total_points_per_coupon
          )
        );
      });
    },

    getWrpValues: (latitude, longitude) => {
      client.get(
        "/v2/?latitude=" +
        latitude +
        "&longitude=" +
        longitude +
        "&feature=1" +
        "&radius=5" +
        "&banner_lang=" +
        currentlySelectedLanguage()
      ).then((response) => {
        var data = response.data.data.wrp;
        dispatch(setWrp(data));
      });
      return;
    },

    addBookmark: (
      id,
      listTypeToUpdate,
      url,
      banner,
      affiliate,
      partner,
      voucher,
      billpay,
      offers,
      tags,
      customer_order_commission,
      wrp
    ) => {
      client
        .post(url, {})
        .then((response) => {
          dispatch(
            setHomeAfterBookmarkToggle(
              id,
              listTypeToUpdate,
              banner,
              affiliate,
              partner,
              voucher,
              billpay,
              offers,
              tags,
              customer_order_commission,
              wrp
            )
          );
        })
        .catch((error) => { });
    },

    deleteBookmark: (
      id,
      listTypeToUpdate,
      url,
      banner,
      affiliate,
      partner,
      voucher,
      billpay,
      offers,
      tags,
      customer_order_commission,
      wrp
    ) => {
      client
        .delete(url)
        .then((response) => {
          dispatch(
            setHomeAfterBookmarkToggle(
              id,
              listTypeToUpdate,
              banner,
              affiliate,
              partner,
              voucher,
              billpay,
              offers,
              tags,
              wrp,
              customer_order_commission
            )
          );
        })
        .catch((error) => { });
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Home);